import { create } from "zustand";

type TutorialStore = {
  /**
   * This flag will cause all stores to be mocked for the tutorial
   */
  isTutorial: boolean;
  setTutorial: (isTutorial: boolean) => void;
};

export const useTutorial = create<TutorialStore>((set) => ({
  isTutorial: false,
  setTutorial: (isTutorial: boolean) => set({ isTutorial }),
}));
